import { useFormContext } from "../context/form-context"
import { ContentType } from "./contents/content-type"

export const Step = ({ stepId, step, class: className }) => {
  const context = useFormContext()

  return step
    ? <div
        id={`step-${stepId}`}
        class={`step ${className || ""} ${step.class || ""}`}
      >
        {step.title && <h1>{step.title}</h1>}
        {step.contents?.map((obj, i) => {
          return (
            <ContentType
              {...obj}
              context={context}
              key={`${stepId}-${obj.type}-${i}`}
            />
          )
        })}
      </div>
    : undefined
}
